import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { portalLogger } from '../utils/portalLogger';

/**
 * Logs page navigation to portal logs
 */
export const PageLogger = () => {
  const location = useLocation();

  useEffect(() => {
    // Map paths to readable names
    const getPageName = (path) => {
      const pathMap = {
        '/dashboard': 'Dashboard',
        '/upload': 'Upload PDFs',
        '/extract': 'Extract Data',
        '/mappings': 'Field Mappings',
        '/audit': 'Audit Logs',
        '/database': 'Database Management',
        '/work-orders': 'Work Orders',
        '/create-work-order': 'Create Work Order',
        '/work-order': 'Work Order Detail',
        '/bulk-create': 'Bulk Create',
        '/bulk-export': 'Bulk Export',
        '/email-work-orders': 'Email Work Orders',
        '/sessions': 'Sessions',
        '/users': 'User Management',
        '/usage-report': 'Usage Report',
        '/analytics': 'Analytics',
        '/original-templates': 'Original Templates',
        '/amc-management': 'AMC Management',
        '/purge-records': 'Purge Records',
        '/settings': 'Settings',
        '/api-logs': 'API Logs',
        '/portal-logs': 'Portal Logs',
        // V1 Pipeline paths
        '/v1': 'V1 Dashboard',
        '/v1/dashboard': 'V1 Dashboard',
        '/v1/xorbit': 'V1 XOrbit',
        '/v1/vja': 'V1 VJA',
        '/v1/comparison': 'V1 Comparison',
        '/v1/stats': 'V1 Statistics',
        '/v1/api-logs': 'V1 API Logs',
        '/v1/portal-logs': 'V1 Portal Logs',
        '/v1/work-order': 'V1 Work Order Detail'
      };

      // Find matching path
      for (const [key, value] of Object.entries(pathMap)) {
        if (path.startsWith(key)) {
          return value;
        }
      }

      return path || 'Home';
    };

    const pageName = getPageName(location.pathname);
    portalLogger.logAction('PAGE_NAVIGATION', `Navigated to ${pageName}`);
  }, [location.pathname]);

  return null;
};

export default PageLogger;
